const itemOrderStatusClasses : Record<string, string> = {
  Raised: "item-order-status-raised",
  Actioned: "item-order-status-actioned",
  Received: "item-order-status-received",
  Abandoned: "item-order-status-abandoned"
};

export { itemOrderStatusClasses };
